import { PaymentsReconciliationsService } from '@festina/moneyin-general-types/moneyin/services/PaymentsReconciliationsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method =
  PaymentsReconciliationsService.paymentReconciliationsServicePostReconcile
type MethodParam = Parameters<typeof method>[0]

export const useSubmitPaymentReconciliation = ({
  tenantId,
}: {
  tenantId: string
}) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles:
      PaymentsReconciliationsService.paymentReconciliationsServicePostReconcile_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ xTenantId: tenantId, ...arg }),
  })
